import { Column } from '../Dynamic';
import { apiClient } from '../../api/apiClient';
import { BASE_ADMIN_API, BASE_API } from '../../config/applicationConfig';
import { useQuery } from '@tanstack/react-query';
import { checkResponse } from '../../util/ResponseHelper';

export interface Product {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  title: string;
  description?: string;
  quantities: number;
  quantitiesType: ProductQuantitiesType;
}

export enum ProductQuantitiesType {
  PIECE = 'PIECE',
  LITRE = 'LITRE',
  GRAMM = 'GRAMM',
  KILOGRAM = 'KILOGRAM',
}

export const productColumns: Column<Product>[] = [
  {
    id: 'title',
    label: 'Titel',
    inputType: 'text',
    gridWidth: 6,
  },
  {
    id: 'description',
    label: 'Beschreibung',
    inputType: 'text',
    gridWidth: 6,
  },
  {
    id: 'quantities',
    label: 'Menge',
    inputType: 'decimal',
    gridWidth: 6,
  },
  {
    id: 'quantitiesType',
    label: 'Einheit',
    inputType: 'select',
    options: [
      { label: 'Gramm', value: ProductQuantitiesType.GRAMM },
      { label: 'Kilogramm', value: ProductQuantitiesType.KILOGRAM },
      { label: 'Liter', value: ProductQuantitiesType.LITRE },
      { label: 'Stück', value: ProductQuantitiesType.PIECE },
    ],
    gridWidth: 6,
  },
  // System fields (read-only)
  {
    id: 'id',
    label: 'ID',
    minWidth: 80,
    disabled: true,
  },
  {
    id: 'publicId',
    label: 'Öffentliche ID',
    inputType: 'text',
    minWidth: 120,
    disabled: true,
  },
  {
    id: 'created',
    label: 'Erstellt',
    inputType: 'datetime',
    minWidth: 150,
    sortable: true,
    disabled: true,
  },
  {
    id: 'createdByEMail',
    label: 'Erstellt von',
    inputType: 'text',
    minWidth: 150,
    sortable: true,
    disabled: true,
  },
  {
    id: 'updated',
    label: 'Geändert',
    inputType: 'datetime',
    minWidth: 150,
    sortable: true,
    disabled: true,
  },
  {
    id: 'updatedByEMail',
    label: 'Geändert von',
    inputType: 'text',
    minWidth: 150,
    sortable: true,
    disabled: true,
  },
];

export const getSelectProduct = async (term: string): Promise<Product[]> => {
  // Wir laden eine große Anzahl von Bildern, um alle verfügbaren zu erhalten
  const params = new URLSearchParams();
  params.append('title', term);
  return checkResponse<Product[]>(
    await apiClient.get(`${BASE_ADMIN_API}/product/select?${params.toString()}`)
  );
};

export interface StockProduct extends Product {
  priceMember: number;
  price: number;
  quantities: number;
}

export const PRODUCT_QUERY_KEYS = {
  all: ['products'] as const,
  list: (stockId: string) => [...PRODUCT_QUERY_KEYS.all, 'list', stockId] as const,
};

export const useProducts = (stockId: string) => {
  return useQuery({
    queryKey: PRODUCT_QUERY_KEYS.list(stockId),
    queryFn: async () => {
      return checkResponse<StockProduct[]>(
        await apiClient.get(BASE_API + `/stock/${stockId}/product/select`)
      );
    },
    enabled: !!stockId,
  });
};
